<template>
  <div>
    <input
      type="file"
      @change="handleFileChange"
      accept=".xlsx,.xls"
    />
  </div>
</template>

<script>
import { preview } from "@/utils/xlsx";

export default {
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      const result =await  preview(file);
      console.log("Preview result:", result);
    }
  }
};
</script>
